import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles.js';
import Layout from './components/layout/Layout.js';
import Hero from './components/pages/Home/Hero.js';
import AboutSection from './components/pages/Home/AboutSection.js';
import ServicesSection from './components/pages/Home/ServicesSection.js';
import FeaturedListings from './components/pages/Home/FeaturedListings.js';
import Testimonials from './components/pages/Home/Testimonials.js';
import CTASection from './components/pages/Home/CTASection.js';
import BlogSection from './components/pages/Home/BlogSection.js';
import HomesForSalePage from './components/pages/ForSale/index.js';
import RentalPropertiesPage from './components/pages/ForRent/index.js';
import LandDevelopmentPage from './components/pages/LandDevelopment/index.js';
import ContactPage from './components/pages/Contact/index.js';
import ThankYouPage from './components/pages/ThankYou/index.js';
import TestimonialsPage from './components/pages/Testimonials/index.js';
import BlogPage from './components/pages/Blog/index.js';
import BlogPostPage from './components/pages/Blog/BlogPost.js';
import LandDevelopmentBlogPage from './components/pages/Blog/LandDevelopment.js';
import AppRoutes from './routes.js';

const App = () => {
  // HomePage component with multiple sections
  const HomePage = () => (
    <Layout isHomePage={true} transparentHeader={true}>
      <Hero />
      <AboutSection />
      <ServicesSection />
      <FeaturedListings />
      <Testimonials />
      <CTASection />
      <BlogSection />
    </Layout>
  );

  // Simple NotFoundPage component
  const NotFoundPage = () => (
    <Layout>
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
      </div>
    </Layout>
  );

  return (
    <Router>
      <GlobalStyles />
      <AppRoutes 
        HomePage={HomePage} 
        HomesForSalePage={HomesForSalePage}
        RentalPropertiesPage={RentalPropertiesPage}
        LandDevelopmentPage={LandDevelopmentPage}
        ContactPage={ContactPage}
        ThankYouPage={ThankYouPage}
        TestimonialsPage={TestimonialsPage}
        BlogPage={BlogPage}
        BlogPostPage={BlogPostPage}
        LandDevelopmentBlogPage={LandDevelopmentBlogPage}
        NotFoundPage={NotFoundPage} 
      />
    </Router>
  );
};

export default App;